import * as constants from '../constants/constants';
import { apiCaller, axiosCaller } from "../utils/apiCaller";
import { ACTION, wrap, setLoading, setButtonLoading }  from './generalActions'
import { toast } from 'react-toastify';
import {translatedText} from "../components/TranslatedText"


export const fetchClientMeasure = (payload: any) => wrap(async(dispatch:any) => {
    try {
        // dispatch(setLoading(true))
        // dispatch(setButtonLoading(true)); Dont setLoader to true for this request
        return await apiCaller('GET', `measures/${payload}`).then(res => {
            dispatch({ "type": constants.FETCH_CLIENT_MEASURE, "payload": res });
            // dispatch(setLoading(false))
            // dispatch(setButtonLoading(false));
            return res
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'GET_CLIENT_MEASURE_ERROR')

export const getClientMeasureByProjectId = (projectId) => wrap(async(dispatch:any) => {
    try {
        // dispatch(setLoading(true))
        // dispatch(setButtonLoading(true)); Dont setLoader to true for this request
        return await apiCaller('GET', `measures/${projectId}/project`).then(res => {
            dispatch({ "type": constants.FETCH_CLIENT_MEASURE, "payload": res });
            // dispatch(setLoading(false))
            // dispatch(setButtonLoading(false));
            return res
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'GET_CLIENT_MEASURE_ERROR')

export const clearAssets = (payload: []): ACTION => ({
    type: constants.CLEAR_ASSETS,
    payload
});

// Pulls a human-readable message out of an axios error. Laravel validation failures (422)
// arrive as { message, errors: { field: [msg, ...] } } — we surface the first field error so
// the user sees the actual reason (e.g. "Video must not be greater than 102400 kilobytes")
// instead of a generic "something went wrong". Falls back gracefully for non-axios errors.
const extractAxiosErrorMessage = (err: any, fallback: string): string => {
    const data = err?.response?.data;
    if (data?.errors && typeof data.errors === 'object') {
        const first = Object.values(data.errors)[0] as any;
        if (Array.isArray(first) && first.length) return first[0];
        if (typeof first === 'string') return first;
    }
    if (typeof data?.message === 'string' && data.message) return data.message;
    // 413 Payload Too Large — PHP rejected the upload at post_max_size before Laravel saw it.
    if (err?.response?.status === 413) return 'File too large for server upload limit';
    if (typeof err?.message === 'string' && err.message) return err.message;
    return fallback;
};

export const createMeasure = (payload:any) => wrap((dispatch:any, state:any) => {
    dispatch(setLoading(true))
    dispatch(setButtonLoading(true));
    const headers = {
        "Accept": "multipart/form-data",
        "Content-Type": "multipart/form-data"
    }

    // The previous sync try/catch was a no-op (axios rejections are async). Without a .catch
    // here the rejection was swallowed by wrap() and loading state stayed true forever — the
    // user saw an infinite spinner and no toast. The .catch below clears loading and surfaces
    // the actual server error.
    return axiosCaller('POST', 'measures', payload, headers, true).then((response:any) => {
        dispatch({ "type": constants.CREATE_MEASURE, payload: response })
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        return response
    }).catch((err: any) => {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        toast.error(extractAxiosErrorMessage(err, translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"})));
        throw err; // re-throw so wrap()'s catch path still runs for the reducer dispatch
    });
}, 'CREATE_MEASURE_ERROR');


export const editMeasure = (id:number, payload:any) => wrap((dispatch:any, state:any) => {
    dispatch(setLoading(true))
    dispatch(setButtonLoading(true));
    return axiosCaller('POST', `measures/${id}`, payload).then((response:any) => {
        dispatch({ "type": constants.EDIT_MEASURE, payload: response })
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        return response
    }).catch((err: any) => {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        toast.error(extractAxiosErrorMessage(err, translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"})));
        throw err;
    });
}, 'EDIT_MEASURE_ERROR');

export const getAssets = (payload: any) => wrap((dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return apiCaller('GET', `measures/assets/${payload}`).then(res => {
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            dispatch({ "type": constants.GET_ASSETS, "payload": res })
        })
    }
    catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"}));
    }
}, 'GET_MEASURE_ASSETS_ERROR')


export const createMeasureTemplate = (payload: object) => wrap((dispatch: any, state: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true))
        return axiosCaller('POST', 'measurement-templates', payload).then((res: any) => {
            dispatch({ "type": constants.CREATE_MEASURE_TEMPLATE, payload: res.data.data[0]})
            toast.success(translatedText({id:"measureTemplateCreated",defaultMessage:"Template per matje u krijua me sukses!"}))
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            return res
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        toast.error(err.message)
    }
}, 'CREATE_MEASURE_TEMPLATE')


export const getAllMeasureTemplates = () => wrap((dispatch: any, state: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return axiosCaller('GET', `measurement-templates`).then((res: any) => {
            dispatch({ type: constants.GET_ALL_MEASURE_TEMPLATES, payload: res.data.data})
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        toast.error(err.message)
    }
}, 'GET_ALL_MEASURE_TEMPLATES')

export const getMeasureTemplate = (id: number) => wrap((dispatch: any, state: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return axiosCaller('GET', `measurement-templates/${id}`).then((res: any) => {
            dispatch({ type: constants.GET_MEASURE_TEMPLATE, payload: res.data.data})
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        toast.error(err.message)
    }
}, 'GET_ALL_MEASURE_TEMPLATES')

export const removeMeasureTemplate = (id: number) => wrap((dispatch: any, state: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true))
        return axiosCaller('DELETE', `measurement-templates/${id}`).then((res: any) => {
            if (res.data.data === true) {
                dispatch(setLoading(false))
                dispatch(setButtonLoading(false));
                toast.info(translatedText({id:"measureTemplateDeleted",defaultMessage:"Template per matje u fshi me sukses!"}))
                // dispatch(getAllMeasureTemplates())
            }
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        toast.error(err.message)
    }
}, 'DELETE_MEASURE_TEMPLATE')

// ─── Dashboard Stats ────────────────────────────────────────────────

export const getMeasureDashboardStats = () => wrap(async (dispatch: any) => {
    try {
        return await apiCaller('GET', 'measures/dashboard-stats').then(res => {
            return res
        })
    } catch (err) {
        // silent fail
    }
}, 'GET_MEASURE_STATS_ERROR')

// ─── Comments ───────────────────────────────────────────────────────

export const getMeasureComments = (measureId: number) => wrap(async (dispatch: any) => {
    try {
        return await apiCaller('GET', `measures/${measureId}/comments`).then(res => {
            return res
        })
    } catch (err) {
        // silent fail
    }
}, 'GET_MEASURE_COMMENTS_ERROR')

export const addMeasureComment = (measureId: number, comment: string) => wrap(async (dispatch: any) => {
    try {
        return await axiosCaller('POST', `measures/${measureId}/comments`, { comment }).then(res => {
            return res
        })
    } catch (err) {
        toast.error(translatedText({id:"commentNotSaved",defaultMessage:"Komenti nuk u ruajt"}));
    }
}, 'ADD_MEASURE_COMMENT_ERROR')

export const deleteMeasureComment = (commentId: number) => wrap(async (dispatch: any) => {
    try {
        return await apiCaller('DELETE', `measures/comments/${commentId}`).then(res => {
            return res
        })
    } catch (err) {
        toast.error(translatedText({id:"commentNotDeleted",defaultMessage:"Komenti nuk u fshi"}));
    }
}, 'DELETE_MEASURE_COMMENT_ERROR')

// ─── Status History ─────────────────────────────────────────────────

export const getMeasureStatusHistory = (measureId: number) => wrap(async (dispatch: any) => {
    try {
        return await apiCaller('GET', `measures/${measureId}/status-history`).then(res => {
            return res
        })
    } catch (err) {
        // silent fail
    }
}, 'GET_MEASURE_STATUS_HISTORY_ERROR')